<template>
  <div
    class="layer-settings__container flex flex-row gap-2
    justify-content-center align-items-center"
    @click.prevent
  >
    <span
      v-tooltip.left="'Reiniciar transparencia'"
      class="layer-settings__transparency-icon material-icons align-self-start mr-1"
      @click="resetTransparency"
    >
      invert_colors_off
    </span>
    <Slider
      v-tooltip.bottom="transparency100 + '% transparencia'"
      :model-value="transparency100"
      class="layer-settings__slider"
      :min="0"
      :max="100"
      :step="1"
      @update:model-value="setTransparency"
    />
    <span class="layer-settings__transparency-icon material-icons align-self-end ml-1">
      invert_colors
    </span>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';
import Slider from 'primevue/slider';

// #region Props, Emits
const props = defineProps({
  layerId: {
    type: String,
    required: true,
  },
});
const emit = defineEmits(['setTransparency']);
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const getLayerState = computed(() => store.getters['layers/getLayerState']);
const transparency100 = computed(() => {
  const transp = getLayerState.value(props.layerId)?.transparency;
  if (!!transp) {
    return Math.round(transp * 100);
  }
  return 0;
});
// #endregion

// #region Functions
async function setTransparency(transp100) {
  const transparency = transp100 / 100;
  const params = {
    layerId: props.layerId,
    transparency,
  };
  emit('setTransparency', params);
}
async function resetTransparency() {
  await setTransparency(0);
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
.layer-settings {
  &__container {
  }
  &__container :deep(.p-panel .p-panel-content) {
    padding: 0.5rem 0.2rem;
  }
  &__transparency {
    &-icon {
      vertical-align: middle;
    }
    &-label {
      text-align: center;
    }
  }
  &__slider {
    width: 100%;
  }
}
</style>
